import { useCallback } from 'react';
import { prop, pick } from 'ramda';
import { log } from 'log';
import { useLiveGamesSelector } from 'js/store/hooks';

export const useLiveGamesSubscribe = () => {
    const socket = useLiveGamesSelector(prop('socket'));
    const { isSocketConnected, isContextSucceeded } = useLiveGamesSelector(pick(['isSocketConnected', 'isContextSucceeded']));

    return useCallback((
        { correlationId, tableAliases = [] }: { correlationId: string; tableAliases: string[] }
    ): void => {
        if (socket && isSocketConnected && isContextSucceeded) {
            const request = {
                correlationId,
                subscribeRequest: {
                    tableAliases
                }
            };

            log('log', '[LIVE | Portal] sending subscribeRequest', request);

            socket.send(request);
        }
    }, [isSocketConnected, socket, isContextSucceeded]);
};
